export default {
    computed: {
        headers() {
            return [
                {
                    value: 'restaurant',
                    text: this.$t('labels.restaurant'),
                    type: 'string',
                    sortable: false,
                },
                {
                    value: 'mealCodes',
                    text: this.$t('labels.allowed_meals'),
                    sortable: false,
                },
            ]
        },
    },
}
